import { useContext } from "react";
import { trans } from "@/service/i18n/i18n";
import { Button } from "@/components/ui/button";
import { UserContext } from "@/contexts/user-context";
import { createPath } from "@/service/routing/routing";
import { SuperLink as Link } from "@/components/common/super-link";

export const WelcomeBecomeMedic = ({ graduate }) => {
  const user = useContext(UserContext);

  return (
    <div>
      <h2
        className={`text-card-foreground mb-6 text-center text-2xl font-semibold`}
      >
        {trans("hello")} {user.shortName},
      </h2>
      <p className={`text-foreground mb-6 text-center text-base font-normal`}>
        {trans("permission.actions_welcome.student.title")}
      </p>

      <Button asChild={true} className={"mb-14 w-full"}>
        <Link href={createPath("homepage")}>{trans("back_to_main_page")}</Link>
      </Button>

      <h3
        className={`text-card-foreground mb-6 text-center text-2xl font-semibold`}
      >
        Skończyłaś/eś już studia?
      </h3>
      <p className={`text-foreground mb-6 text-center text-base font-normal`}>
        {trans("permission.actions_welcome.student.finish")}
      </p>
      <Button variant={"outline"} className={"w-full"} onClick={graduate}>
        {trans("permission.actions_welcome.student.finished")}
      </Button>
    </div>
  );
};
